module.exports = __webpack_public_path__ + "96a1ab1fd6e0e8f252eef63b727e5403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat-welcome-hero.png
// module id = 2329
// module chunks = 0 1